<template>
	<div>
		<p>
            <span v-if="$tera.project.AuditWizard.participantsRecruitedFrom && $tera.project.AuditWizard.participantsRecruitedFrom.length || $tera.project.AuditWizard.healthServicesParticipantsRecruited && $tera.project.AuditWizard.healthServicesParticipantsRecruited.length">
                <span v-if="$tera.project.participantsRecruitedFrom && $tera.project.participantsRecruitedFrom.length">
                {{
                    selectRandom([
                        "Participants will be recruited from the following: ",
                        "Recruitment of participants will occur from the following: ",
                        "The recruitment process will involve participants from the following: ",
                        "The following will serve as the sources for participant recruitment: ",
                        "Participants will be gathered from the following: "
                    ])
                }}
                </span>
                <span v-if="$tera.project.AuditWizard.participantsRecruitedFrom && $tera.project.AuditWizard.participantsRecruitedFrom.length">
                    {{ joinArrayWithAnd(formatSelectMulti($tera.project.AuditWizard.participantsRecruitedFrom))+ "." }}
                </span>
                
                <span v-if="$tera.project.AuditWizard.healthServicesParticipantsRecruited && $tera.project.AuditWizard.healthServicesParticipantsRecruited.length">
                {{
                    selectRandom([
                        "Participants will be recruited from the following health services: ",
                        "Recruitment of participants will take place through the following health services: ",
                        "The recruitment process will involve participants from these health services:",
                        "Participants will be gathered from the following list of health services:",
                        "The following health services will serve as sources for participant recruitment: "
                    ])
                }}
                </span>
                <span v-if="$tera.project.AuditWizard.healthServicesParticipantsRecruited && $tera.project.AuditWizard.healthServicesParticipantsRecruited.length">
                    {{ joinArrayWithAnd(formatSelectMulti($tera.project.AuditWizard.healthServicesParticipantsRecruited)) }}
                </span>
        </span>
        <span v-else> {{ $tera.project.AuditWizard.noStudySetting }} </span>
			
				
		</p>
	</div>
</template>

<script>
import OutputMixin from "@/mixins/OutputMixin.js";
export default {
	name: "OutputAuditStudySetting",
	mixins: [OutputMixin]
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped></style>
